import React from 'react'
import { Box, Tooltip, Typography, Zoom } from '@mui/material'
import {
  IconCalendarCheck,
  IconEye,
  IconMessageDots,
} from '@tabler/icons-react'
import ImgIcon from '../../../../../components/ui/ImgIcon'
import useAppUtilities from '../../../../../hooks/useAppUtilities'
import { VistitorEater } from '../../../../../types/dashboard'
import { setSelectedUser } from '../../../../../store/restaurant/messages'
import {
  DEFAULT_AVATAR_IMAGE,
  toTalkPhotoUrl,
} from '../../../../../helpers/static-constants'
import { ROUTES } from '../../../../../helpers/routes-helper'

interface VisitorActionProps {
  visitor: VistitorEater
}

const VisitorAction: React.FC<VisitorActionProps> = ({ visitor }) => {
  const { theme, dispatch, navigate } = useAppUtilities()

  const onVisitorMessage = async (user: VistitorEater): Promise<void> => {
    if (user?.eaterId) {
      const photoUrl = toTalkPhotoUrl(user?.imageUrl, DEFAULT_AVATAR_IMAGE)
      dispatch(
        setSelectedUser({
          id: user?.eaterId ?? '',
          name: user.name,
          email: [user.email ?? ''],
          role: 'customer',
          ...(photoUrl ? { photoUrl } : {}),
        }),
      )
      navigate(ROUTES.RESTAURANT_MESSAGES)
    }
  }

  return (
    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
      <Tooltip
        title="Views"
        arrow
        placement="top"
        slotProps={{
          popper: {
            sx: {
              '& .MuiTooltip-tooltip': {
                color: 'primary.main',
                bgcolor: 'background.paper',
              },
            },
          },
          tooltip: {
            sx: {
              backgroundColor: 'background.paper',
              borderRadius: '10px',
              padding: '8px 12px',
              boxShadow: 6,
            },
          },
        }}
        slots={{
          transition: Zoom,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={0.5}
          bgcolor="grey.100"
          py={0.5}
          borderRadius={8}
          minWidth={55}
        >
          <IconEye stroke={2} size={16} />
          <Typography variant="subtitle2">{visitor?.viewCount}</Typography>
        </Box>
      </Tooltip>
      <Tooltip
        title="Reservations"
        arrow
        placement="top"
        slotProps={{
          popper: {
            sx: {
              '& .MuiTooltip-tooltip': {
                color: 'primary.main',
                bgcolor: 'background.paper',
              },
            },
          },
          tooltip: {
            sx: {
              backgroundColor: 'background.paper',
              borderRadius: '10px',
              padding: '8px 12px',
              boxShadow: 6,
            },
          },
        }}
        slots={{
          transition: Zoom,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={0.5}
          py={0.5}
          borderRadius={8}
          bgcolor="grey.100"
          minWidth={55}
        >
          <IconCalendarCheck stroke={2} size={16} />
          <Typography variant="subtitle2">
            {visitor?.reservationCount ?? 0}
          </Typography>
        </Box>
      </Tooltip>
      <ImgIcon
        disable={!visitor?.eaterId}
        onClick={() => {
          void onVisitorMessage(visitor)
        }}
        iconElement={
          <IconMessageDots
            stroke={2}
            size={18}
            color={theme.palette.grey[500]}
          />
        }
        alt="confirm-edit"
        wrapperStyle={{
          width: '36px',
          height: '36px',
          backgroundColor: theme.palette.grey[50],
          border: `1px solid ${theme.palette.grey[300]}`,
        }}
      />
    </Box>
  )
}

export default VisitorAction
